<article class="ts-page">
  <header class="ts-page__head">
    <p class="t-meta ts-page__eyebrow">Legal</p>
    <h1 class="ts-page__title">Terms of service</h1>
    <p class="ts-page__lede">What you need to know before using Talespinner.</p>
  </header>

  <div class="ts-doc">
    <nav class="ts-doc__toc" aria-label="Contents">
      <p class="t-meta">Contents</p>
      <ol>
        <li><a [routerLink]="[]" fragment="acceptance-of-terms">Acceptance of Terms</a></li>
        <li><a [routerLink]="[]" fragment="intellectual-property">Intellectual Property</a></li>
        <li><a [routerLink]="[]" fragment="amendments-to-terms-and-conditions">Amendments to Terms & Conditions</a></li>
        <li><a [routerLink]="[]" fragment="user-eligibility">User Eligibility</a></li>
        <li><a [routerLink]="[]" fragment="termination-of-service">Termination of Service</a></li>
        <li><a [routerLink]="[]" fragment="artificial-intelligence-disclaimer">Artificial Intelligence Disclaimer</a></li>
        <li><a [routerLink]="[]" fragment="third-party-ai-software-providers">Third-party AI Software Providers</a></li>
        <li><a [routerLink]="[]" fragment="content-removal">Content Removal</a></li>
        <li><a [routerLink]="[]" fragment="limitation-of-liability">Limitation of Liability</a></li>
        <li><a [routerLink]="[]" fragment="severability">Severability</a></li>
        <li><a [routerLink]="[]" fragment="force-majeure">Force Majeure</a></li>
        <li><a [routerLink]="[]" fragment="governing-law-and-jurisdiction">Governing Law & Jurisdiction</a></li>
        <li><a [routerLink]="[]" fragment="user-generated-content">User-Generated Content</a></li>
        <li><a [routerLink]="[]" fragment="data-privacy-and-security">Data Privacy and Security</a></li>
        <li><a [routerLink]="[]" fragment="acceptable-use-policy">Acceptable Use Policy</a></li>
        <li><a [routerLink]="[]" fragment="payment-and-refunds">Payment and Refunds</a></li>
        <li><a [routerLink]="[]" fragment="disclaimer-of-warranties">Disclaimer of Warranties</a></li>
        <li><a [routerLink]="[]" fragment="indemnification">Indemnification</a></li>
        <li><a [routerLink]="[]" fragment="copyright-infringement-reporting">Copyright Infringement Reporting</a></li>
        <li><a [routerLink]="[]" fragment="account-security">Account Security</a></li>
      </ol>
    </nav>

    <div class="ts-prose">
      <section class="ts-prose__section" id="acceptance-of-terms">
        <span class="ts-prose__number">§ 01</span>
        <h2>Acceptance of Terms</h2>
        <p>By accessing or using talespinner.io (the "Website"), owned by Bons AI ("Company"), you ("User" or "Customer") agree to these Terms & Conditions. If you do not agree, you must refrain from using this Website.</p>
      </section>

      <section class="ts-prose__section" id="intellectual-property">
        <span class="ts-prose__number">§ 02</span>
        <h2>Intellectual Property</h2>
        <p>Users warrant that any content they create or upload does not violate any third-party intellectual property rights. The Company shall not be held liable for any such infringements. Should any third-party claims arise due to such violations, they will be directed to and recouped from the User.</p>
      </section>

      <section class="ts-prose__section" id="amendments-to-terms-and-conditions">
        <span class="ts-prose__number">§ 03</span>
        <h2>Amendments to Terms & Conditions</h2>
        <p>The Company reserves the right to update or change these Terms & Conditions periodically. It's the User's responsibility to review and adhere to these changes to continue accessing the Website.</p>
      </section>

      <section class="ts-prose__section" id="user-eligibility">
        <span class="ts-prose__number">§ 04</span>
        <h2>User Eligibility</h2>
        <p>By agreeing to these terms, the User confirms they are at least 13 years old or have attained the minimum legal age in their jurisdiction. Users below this age need parental or guardian consent, whereby the terms apply to the consenting adult.</p>
      </section>

      <section class="ts-prose__section" id="termination-of-service">
        <span class="ts-prose__number">§ 05</span>
        <h2>Termination of Service</h2>
        <p>The Company reserves the right to terminate any User's access or collaboration at any point, without notice.</p>
      </section>

      <section class="ts-prose__section" id="artificial-intelligence-disclaimer">
        <span class="ts-prose__number">§ 06</span>
        <h2>Artificial Intelligence Disclaimer</h2>
        <p>Users acknowledge that artificial intelligence is a nascent technology. The Company cannot guarantee the accuracy or desirability of content generated. Furthermore, there's a possibility the generated content may not align with a User's preference or intent.</p>
      </section>

      <section class="ts-prose__section" id="third-party-ai-software-providers">
        <span class="ts-prose__number">§ 07</span>
        <h2>Third-party AI Software Providers</h2>
        <p>Besides agreeing to these terms, Users also acknowledge and agree to the terms and conditions set by our AI software partners:</p>
        <ul>
          <li><a href="https://console.anthropic.com/legal/terms">Claude (Claude's Terms)</a></li>
          <li><a href="https://openai.com/policies">ChatGPT (ChatGPT's Terms)</a></li>
          <li><a href="https://openrouter.ai/terms">OpenRouter (OpenRouter's Terms)</a></li>
        </ul>
      </section>

      <section class="ts-prose__section" id="content-removal">
        <span class="ts-prose__number">§ 08</span>
        <h2>Content Removal</h2>
        <p>The Company reserves the right to remove any content submitted by the User or generated on the User's behalf, without stating reasons.</p>
      </section>

      <section class="ts-prose__section" id="limitation-of-liability">
        <span class="ts-prose__number">§ 09</span>
        <h2>Limitation of Liability</h2>
        <p>Users understand the Company is not responsible for any loss of profit, goodwill, or data. It's the User's duty to manage and store their data properly.</p>
      </section>

      <section class="ts-prose__section" id="severability">
        <span class="ts-prose__number">§ 10</span>
        <h2>Severability</h2>
        <p>If any provision of these terms is found invalid, the remaining provisions remain in effect.</p>
      </section>

      <section class="ts-prose__section" id="force-majeure">
        <span class="ts-prose__number">§ 11</span>
        <h2>Force Majeure</h2>
        <p>The Company is not liable for any failure or delay in fulfilling any of its service obligations caused by events outside its reasonable control.</p>
      </section>

      <section class="ts-prose__section" id="governing-law-and-jurisdiction">
        <span class="ts-prose__number">§ 12</span>
        <h2>Governing Law & Jurisdiction</h2>
        <p>Any disputes arising from these terms shall be resolved in the Arnhem court, Netherlands, with Dutch law being applicable.</p>
      </section>

      <section class="ts-prose__section" id="user-generated-content">
        <span class="ts-prose__number">§ 13</span>
        <h2>User-Generated Content</h2>
        <p>Users retain ownership of any original content they create using our service. However, by using talespinner.io, users grant the Company a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and distribute the content generated through our platform for the purposes of providing and improving our services.</p>
      </section>

      <section class="ts-prose__section" id="data-privacy-and-security">
        <span class="ts-prose__number">§ 14</span>
        <h2>Data Privacy and Security</h2>
        <p>The Company is committed to protecting user privacy and data. Users should refer to our separate Privacy Policy for details on how we collect, use, and protect personal information. Users are responsible for ensuring the security of their account credentials.</p>
      </section>

      <section class="ts-prose__section" id="acceptable-use-policy">
        <span class="ts-prose__number">§ 15</span>
        <h2>Acceptable Use Policy</h2>
        <p>Users agree not to use talespinner.io to generate or distribute content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, invasive of another's privacy, or otherwise objectionable. The Company reserves the right to remove such content and terminate accounts of users who violate this policy.</p>
      </section>

      <section class="ts-prose__section" id="payment-and-refunds">
        <span class="ts-prose__number">§ 16</span>
        <h2>Payment and Refunds</h2>
        <p>Details about our pricing, payment terms, and refund policy should be clearly outlined. Include information about subscription models, if applicable, and the process for cancellation.</p>
      </section>

      <section class="ts-prose__section" id="disclaimer-of-warranties">
        <span class="ts-prose__number">§ 17</span>
        <h2>Disclaimer of Warranties</h2>
        <p>The Company provides the service on an "as is" and "as available" basis, without any warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>
      </section>

      <section class="ts-prose__section" id="indemnification">
        <span class="ts-prose__number">§ 18</span>
        <h2>Indemnification</h2>
        <p>Users agree to indemnify and hold harmless the Company, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) arising out of or related to their use of talespinner.io or any violation of these Terms & Conditions.</p>
      </section>

      <section class="ts-prose__section" id="copyright-infringement-reporting">
        <span class="ts-prose__number">§ 19</span>
        <h2>Copyright Infringement Reporting</h2>
        <p>If you believe that your copyrighted work has been copied in a way that constitutes copyright infringement and is accessible on this site, please contact us at <a href="mailto:copyright@talespinner.io">copyright&#64;talespinner.io</a> with the following information:</p>
        <ul>
          <li>A description of the copyrighted work that you claim has been infringed;</li>
          <li>The URL or other specific location on our site where the material that you claim is infringing is located;</li>
          <li>Your address, telephone number, and email address;</li>
          <li>A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;</li>
          <li>A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.</li>
        </ul>
      </section>

      <section class="ts-prose__section" id="account-security">
        <span class="ts-prose__number">§ 20</span>
        <h2>Account Security</h2>
        <p>Users are responsible for maintaining the confidentiality of their account information and password. They agree to notify the Company immediately of any unauthorized use of their account or any other breach of security.</p>
      </section>

      <p class="ts-legal__closing">By using talespinner.io, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.</p>

      <p class="ts-legal__back">Back to the <a routerLink="/account/auth/signup">Registration form</a></p>
    </div>
  </div>
</article>
